import { useEffect } from "react";

export const SITE_URL = "https://finainterior.com";
const DEFAULT_IMAGE = `${SITE_URL}/logo.png`;

const cleanText = (value, fallback = "") => {
  if (typeof value !== "string") return fallback;
  return value.replace(/<[^>]*>/g, " ").replace(/\s+/g, " ").trim() || fallback;
};

const setMeta = (attribute, key, content) => {
  let tag = document.head.querySelector(`meta[${attribute}="${key}"]`);
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute(attribute, key);
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", content);
};

const Seo = ({
  title,
  description,
  path,
  image = DEFAULT_IMAGE,
  type = "website",
  noindex = false,
  schema,
}) => {
  useEffect(() => {
    const pageTitle = cleanText(title, "Fina Interiors");
    const pageDescription = cleanText(
      description,
      "Discover furniture and personalized interior design solutions from Fina Interiors in Pune."
    ).slice(0, 160);
    const canonicalUrl = `${SITE_URL}${path || window.location.pathname}`;
    const socialImage = image?.startsWith("http")
      ? image
      : `${SITE_URL}${image?.startsWith("/") ? image : `/${image}`}`;

    document.title = pageTitle;
    setMeta("name", "description", pageDescription);
    setMeta("name", "robots", noindex ? "noindex, nofollow" : "index, follow");
    setMeta("property", "og:site_name", "Fina Interiors");
    setMeta("property", "og:title", pageTitle);
    setMeta("property", "og:description", pageDescription);
    setMeta("property", "og:type", type);
    setMeta("property", "og:url", canonicalUrl);
    setMeta("property", "og:image", socialImage);
    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:title", pageTitle);
    setMeta("name", "twitter:description", pageDescription);
    setMeta("name", "twitter:image", socialImage);

    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", canonicalUrl);

    const schemaTag = document.getElementById("page-schema");
    if (schema) {
      const tag = schemaTag || document.createElement("script");
      tag.id = "page-schema";
      tag.type = "application/ld+json";
      tag.textContent = JSON.stringify(schema);
      if (!schemaTag) document.head.appendChild(tag);
    } else if (schemaTag) {
      schemaTag.remove();
    }
  }, [description, image, noindex, path, schema, title, type]);

  return null;
};

export default Seo;
